export default __webpack_public_path__ + "static/media/Sintony-Bold.a28bfdd8.woff";